export const current = (state: any) => state.version;
export const date = (state: any) => {
  const parsedDate = new Date(state.date);
  return `${parsedDate.getDate()}.${parsedDate.getUTCMonth() + 1}.${parsedDate.getUTCFullYear()}`;
};
export const expected = () => '1.8';
